import axios from 'axios'
import { API_ROUTES } from '../routes'

export const updateEmployeeCost = (employeeCostMapping: any) => {
  return axios.post(API_ROUTES.EMPLOYEE_COST, employeeCostMapping)
}
